document.addEventListener("DOMContentLoaded", function () {
  function timeAgo(dateString) {
    if (!dateString || !dateString.includes("/")) return dateString;
    var parts = dateString.split("/");
    var reviewDate = new Date(parts[2], parts[1] - 1, parts[0]);
    var diffDays = Math.floor(
      Math.abs(new Date() - reviewDate) / (1000 * 60 * 60 * 24),
    );

    if (diffDays === 0) return "Hoje";
    if (diffDays === 1) return "Ontem";
    if (diffDays < 30) return "há " + diffDays + " dias";
    var diffMonths = Math.floor(diffDays / 30);
    if (diffMonths < 12)
      return diffMonths === 1 ? "há 1 mês" : "há " + diffMonths + " meses";
    var diffYears = Math.floor(diffDays / 365);
    return diffYears === 1 ? "há 1 ano" : "há " + diffYears + " anos";
  }

  var attempts = 0;
  var interval = setInterval(function () {
    attempts++;
    var dates = document.querySelectorAll(
      ".jm-reviewer-info__details .jm-text",
    );
    var changedSomething = false;

    dates.forEach(function (el) {
      var text = el.innerText.trim();
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(text)) {
        el.innerText = timeAgo(text);
        changedSomething = true;
      }
    });

    if (changedSomething || attempts > 10) {
      clearInterval(interval);
    }
  }, 500);
});
